import React from 'react';
import { Tag } from 'lucide-react';

/**
 * Sidebar widget that lists every admin-managed pricing scheme as a radio.
 * When the user picks a scheme, the parent re-prices the cart using
 * `priceForScheme` (passed in) so any admin scheme — including custom ones —
 * works without code changes here.
 *
 * `isAdmin` controls whether the markup % is shown beneath each scheme name.
 * Non-admin users (e.g., sales staff) see only the scheme label.
 */
export const PriceSchemeSelector = ({
  priceSchemes,
  selectedScheme,
  onSelectScheme,
  isAdmin = false,
}) => {
  if (!priceSchemes || priceSchemes.length === 0) return null;
  return (
    <div className="bg-card p-6 rounded-lg border border-border" data-testid="price-scheme-panel">
      <h3 className="text-sm font-semibold mb-3 flex items-center gap-2">
        <Tag className="h-4 w-4" /> Price Scheme
      </h3>
      <div className="space-y-2">
        {priceSchemes.map((scheme) => (
          <label
            key={scheme.name}
            className={`flex items-center gap-3 p-2.5 rounded-md border cursor-pointer transition-colors ${
              selectedScheme === scheme.name
                ? 'border-primary bg-primary/5'
                : 'border-border hover:bg-muted/50'
            }`}
            data-testid={`scheme-${scheme.name}`}
          >
            <input
              type="radio"
              name="priceScheme"
              value={scheme.name}
              checked={selectedScheme === scheme.name}
              onChange={() => onSelectScheme(scheme)}
              className="accent-primary"
            />
            <div>
              <p className="text-sm font-medium">{scheme.label}</p>
              {isAdmin && (
                <p className="text-xs text-muted-foreground">
                  {scheme.markup_percent > 0
                    ? `${scheme.markup_percent}% markup over cost`
                    : 'Cost price (no markup)'}
                </p>
              )}
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};
